import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import jwtService from '../../services/jwtService';
import PhoneInput from 'react-phone-input-2';
import { toastr } from 'react-redux-toastr';

const Profile = () => {
    const { data: userData } = useSelector(state => state.user);
    const [mobileNumber, setMobileNumber] = useState({
        'code': '1',
        'phone': '',
        'actualPhoneNumber': ''
    });
    const [error, setError] = useState('');
    const [edit, setEdit] = useState(false);

    useEffect(() => {
        setMobileNumber({
            'code': userData?.country_code || '',
            'phone': userData?.phone_number || '',
            'actualPhoneNumber': userData?.country_code + userData?.phone_number || '',
        });
    }, [userData]);


    const handleMobileNumberChange = (value, data) => {
        const tempPhoneInfo = { ...mobileNumber };
        tempPhoneInfo.actualPhoneNumber = value;
        tempPhoneInfo.code = data.dialCode;
        tempPhoneInfo.phone = value.slice(data.dialCode.length);
        setMobileNumber(tempPhoneInfo);
        setError('');
    };

    const handleSubmit = async () => {
        if (!validateMobileNumber()) {
            setError('Please enter a valid mobile number');
            return;
        }
        let data = {
            phone_number: mobileNumber.phone,
            country_code: mobileNumber.code,
        };
        try {
            let res = await jwtService.editUser(data);
            toastr.success(res.msg);
            setEdit(false);
        } catch (error) {
            toastr.success(error.data.msg);
            console.log(error);
        }
    };

    const validateMobileNumber = () => {
        const mobileNumberRegex = /^[0-9]{10}$/;
        return mobileNumberRegex.test(mobileNumber.phone);
    };
    return (
        <div className="bg-gradient my-account-section changes-pass">
            <div className="main-container my-account-detail div-1">
                <Grid container className="my-account__header mx-auto bg-head-gray text-white align-items-center">
                    <Grid item xs={12} className="pr-0 text-left user-name">
                        <span className="my-account__text player-name d-block ellipsis">{userData && userData.username}</span>
                    </Grid>
                </Grid>
                <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                    <input
                        type="text"
                        value={userData && userData.email}
                        class="profile-input mt-1"
                        readOnly
                    />
                </div>
                <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                    <PhoneInput
                        inputProps={{
                            name: 'inputPhoneNo',
                        }}
                        country={'us'}
                        containerClass="pnone-input"
                        enableSearch
                        onChange={(value, code) => handleMobileNumberChange(value, code)}
                        value={mobileNumber.actualPhoneNumber}
                        disabled={!edit}
                        onMouseLeave={() => setEdit(false)}
                    />
                    {edit ?
                        <img src="/images/save.svg" onClick={handleSubmit} width={25} height={25} alt='save' />
                        :
                        <img src="/images/edit.svg" onClick={() => setEdit(true)} width={25} height={25} alt='edit' />
                    }
                </div>
                {error && <div className="error">{error}</div>}
            </div>
        </div>
    );
};

export default Profile;